import { Controller } from "@hotwired/stimulus"

// Controller for selecting and adding store items to cart
export default class extends Controller {
  static targets = ["storeItem", "quantityInput", "addButton", "message", "itemDetails"]

  static values = {
    addUrl: String,
    opportunityId: Number,
    items: Array
  }

  connect() {
    console.log("Store Item Selector Controller connected")
    this.updateButtonState()
  }

  storeItemChanged() {
    console.log("Store item changed:", this.storeItemTarget.value)
    this.updateButtonState()
    this.updateItemDetails()
    this.hideMessage()
  }

  quantityChanged() {
    console.log("Quantity changed:", this.quantityInputTarget.value)
    this.updateButtonState()
  }

  updateButtonState() {
    const itemId = this.storeItemTarget.value
    const quantity = parseInt(this.quantityInputTarget.value) || 0

    // Enable button only if item is selected and quantity > 0
    const shouldEnable = itemId && quantity > 0
    this.addButtonTarget.disabled = !shouldEnable

    console.log("Button state updated:", { itemId, quantity, enabled: shouldEnable })
  }

  updateItemDetails() {
    if (!this.hasItemDetailsTarget) return

    const itemId = this.storeItemTarget.value
    if (!itemId) {
      this.itemDetailsTarget.classList.add('hide')
      this.itemDetailsTarget.innerHTML = ''
      return
    }

    const item = this.itemsValue.find(i => i.id.toString() === itemId)
    if (item && item.description) {
      this.itemDetailsTarget.innerHTML = `<p class="text-muted small mt-2">${item.description}</p>`
      this.itemDetailsTarget.classList.remove('hide')
    } else {
      this.itemDetailsTarget.classList.add('hide')
    }
  }

  addToCart() {
    const itemId = this.storeItemTarget.value
    const quantity = parseInt(this.quantityInputTarget.value) || 1

    if (!itemId) {
      this.showMessage("Please select an item", "warning")
      return
    }

    // Disable button while adding
    this.addButtonTarget.disabled = true
    this.addButtonTarget.innerHTML = '<i class="fas fa-spinner fa-spin me-2"></i>Adding...'

    fetch(this.addUrlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({
        store_item_id: itemId,
        quantity: quantity,
        opportunity_id: this.opportunityIdValue
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log("Add store item response:", data)
      if (data.success) {
        this.showMessage("Item added to cart!", "success")

        // Reset form
        this.storeItemTarget.value = ""
        this.quantityInputTarget.value = 1
        if (this.hasItemDetailsTarget) {
          this.itemDetailsTarget.classList.add('hide')
        }

        // Dispatch event for cart to update
        document.dispatchEvent(new CustomEvent('cartUpdated', { detail: data }))

        // Reload page to show updated cart
        if (data.redirect_url) {
          window.location.href = data.redirect_url
        } else {
          window.location.reload()
        }
      } else {
        this.showMessage(data.error || "Failed to add item", "danger")
      }
    })
    .catch(error => {
      console.error("Error adding store item:", error)
      this.showMessage("An error occurred. Please try again.", "danger")
    })
    .finally(() => {
      this.addButtonTarget.disabled = false
      this.addButtonTarget.innerHTML = '<i class="fas fa-plus-circle me-2"></i>Add to Cart'
      this.updateButtonState()
    })
  }

  showMessage(text, type) {
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = text
      this.messageTarget.className = `alert alert-${type} mt-3`
      this.messageTarget.classList.remove('d-none')
    }
  }

  hideMessage() {
    if (this.hasMessageTarget) {
      this.messageTarget.classList.add('d-none')
    }
  }
}
